<template>
  <div   class="animated fadeIn">
      <Alerts ref="alert"/>
      <b-tabs v-model="tabIndex">
        <b-tab :title="$lang.Sinister.General.Search" v-if="hasRole(this.roles.RW_REG_TABSEARCH)" active @click="setTabName('Search')">
          <template slot="title">
            <i class="fa fa-search text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.General.Search }}</span>
          </template>
          <SinisterSearch ref="Search" @Edit="onEdit" @ClearTabs="onClearTabs" @MoveTabIndex="moveTabIndex"/>
        </b-tab>
        <b-tab :title="$lang.Sinister.General.Details" v-if="hasRole(this.roles.RD_REG_TABDETAILS) || hasRole(this.roles.RW_REG_TABDETAILS)" @click="setTabName('Details')">
          <template slot="title">
            <i class="fa fa-file-text-o text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.General.Details }}</span>
          </template>
          <SinisterDetails ref="Details" :clear="clearAllTabs" />
        </b-tab>
        <b-tab :title="$lang.Sinister.General.Scheduling" v-if="hasRole(this.roles.RD_REG_TABSCHEDULING) || hasRole(this.roles.RW_REG_TABSCHEDULING)" @click="setTabName('Scheduling')">
          <template slot="title">
            <i class="fa fa-calendar text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.General.Scheduling }}</span>
          </template>
          <SinisterScheduling ref="Scheduling"/>
        </b-tab>
        <b-tab :title="$lang.Sinister.General.WorkshopReturn" v-if="hasRole(this.roles.RD_REG_TABWORKSHOP) || hasRole(this.roles.RW_REG_TABWORKSHOP)" @click="setTabName('WorkshopReturn')">
          <template slot="title">
            <i class="fa fa-wrench text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.General.WorkshopReturn }}</span>
          </template>
          <SinisterWorkshopReturn :clear="clearAllTabs" ref="SinisterWorkshopReturn"/>
        </b-tab>
        <b-tab :title="$lang.Sinister.General.Regulation" v-if="hasRole(this.roles.RD_REG_TABREGULATION) || hasRole(this.roles.RW_REG_TABREGULATION)" @click="setTabName('Regulation')">
          <template slot="title">
            <i class="fa fa-book text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.General.Regulation }}</span>
          </template>
          <SinisterRegulation :clear="clearAllTabs" ref="SinisterRegulation"/>
        </b-tab>
        <b-tab :title="$lang.Sinister.General.Analyze" v-if="hasRole(this.roles.RD_REG_TABANALYZE) || hasRole(this.roles.RW_REG_TABANALYZE)" @click="setTabName('Analyze')">
          <template slot="title">
            <i class="fa fa-calculator text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.General.Analyze }}</span>
          </template>
          <SinisterAnalyze :clear="clearAllTabs" ref="SinisterAnalyze"/>
        </b-tab>
        <b-tab :title="$lang.Sinister.General.Typing" v-if="hasRole(this.roles.RD_REG_TABDIGITATION) || hasRole(this.roles.RW_REG_TABDIGITATION)" @click="setTabName('Typing')">
          <template slot="title">
            <i class="fa fa-pencil-square-o text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.General.Typing }}</span>
          </template>
          <SinisterTyping :clear="clearAllTabs" ref="SinisterTyping"/>
        </b-tab>
        <b-tab :title="'Orion'" @click="setTabName('History')">
          <template slot="title">
            <i class="fa fa-globe text-third"></i><span class="d-md-down-none pl-1 text-third">Orion</span>
          </template>
          <embed type="text/html" src="https://cesvi.orionbr.com.br/ORION/REGULADORA/ORCAMENTOS/#/main/home-reguladora" height="1000" style="width: 100%; border: solid 1px #ccc;">
        </b-tab>
        <!--
        <b-tab :title="$lang.Sinister.General.History" @click="setTabName('History')">
          <template slot="title">
            <i class="fa fa-history text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.General.History }}</span>
          </template>
          <SinisterHistory ref="History"/>
        </b-tab>
        -->
      </b-tabs>
  </div>
</template>

<script>
import Alerts from '@/components/forms/Alerts'
// import Tools from '@/components/tools/Tools.js'

import SinisterSearch from './search/SinisterSearch.vue'
import SinisterDetails from './details/sinisterdetails.vue'
import SinisterScheduling from './scheduling/sinisterscheduling.vue'
import SinisterWorkshopReturn from './workshopreturn/SinisterWorkshopReturn.vue'
import SinisterTyping from './typing/SinisterTyping.vue'
import SinisterAnalyze from './analyze/SinisterAnalyze.vue'
import SinisterRegulation from './regulation/sinisterregulation.vue'
import SinisterHistory from './history/SinisterHistory.vue'

import SinisterDetailsModel from '@/shared/models/regulation/auto/sinisterdetailsmodel'

import AccountMixin from '@/store/module/account/mixin'
import { actionTypes as AccountActions } from '@/store/module/account/actions'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

const TAB_IDX_DETAILS = 1
const TAB_DETAILS = 'Details'
const TAB_SCHEDULING = 'Scheduling'
const TAB_WORKSHOPRETURN = 'WorkshopReturn'
const TAB_REGULATION = 'Regulation'
const TAB_ANALYZE = 'Analyze'
const TAB_TYPING = 'Typing'
// const TAB_HISTORY = 'History'

export default {
  name: 'sinister',
  mixins: [ AccountMixin, PermissionMixin ],
  data () {
    return {
      roles: Roles,
      data: SinisterDetailsModel,
      objRegulationAuto: {},
      regulation: {},
      error: null,
      tabName: null,
      tabIndex: 0,
      isLoadDetails: false,
      isLoadScheduling: false,
      isLoadWorkshopReturn: false,
      isLoadRegulation: false,
      isLoadAnalyze: false,
      isLoadTyping: false,
      isLoadMonitoring: false,
      isLoadHistory: false,
      clearAllTabs: false
    }
  },
  created () {
    this[AccountActions.GET_LOGGED]()
      .then((response) => {
      })
  },
  components: {
    Alerts,
    SinisterSearch,
    SinisterDetails,
    SinisterScheduling,
    SinisterWorkshopReturn,
    SinisterTyping,
    SinisterAnalyze,
    SinisterHistory,
    SinisterRegulation,
    SinisterDetailsModel
  },
  watch: {
    tabIndex: function () {
      if (this.tabName === TAB_SCHEDULING && !this.isLoadScheduling) {
        if (this.objRegulationAuto) {
          this.$refs.Scheduling.onLoad(this.objRegulationAuto)
        }
        // TODO Load por demanda
        // this.isLoadScheduling = true
      }
      if (this.tabName === TAB_WORKSHOPRETURN && !this.isLoadWorkshopReturn) {
        this.$refs.SinisterWorkshopReturn.onLoad(this.objRegulationAuto)
        // TODO Load por demanda
      }
      if (this.tabName === TAB_REGULATION && !this.isLoadRegulation) {
        this.$refs.SinisterRegulation.onLoad(this.objRegulationAuto.id)
      }
      if (this.tabName === TAB_ANALYZE && !this.isLoadAnalyze) {
        this.$refs.SinisterAnalyze.onLoad(this.objRegulationAuto.id)
      }
      if (this.tabName === TAB_TYPING && !this.isLoadTyping) {
        this.$refs.SinisterTyping.onLoad(this.objRegulationAuto.id)
      }
    }
  },
  methods: {
    onClearTabs (clearFn) {
      this.objRegulationAuto.id = 'undefined'
      this.$refs.Details.onClear()
      this.$refs.SinisterWorkshopReturn.$refs.SinisterHeader.onClear()
      // TODO REMOVER APÓS REFACTOR
      if (this.clearAllTabs) {
        this.clearAllTabs = false
        return
      }
      this.clearAllTabs = true
    },
    onChangeRegulation (value) {
      this.objRegulationAuto.id = value
    },
    onEdit (obj) {
      this.objRegulationAuto = obj
      if (this.$refs.Details) {
        this.$refs.Details.onEdit(this.objRegulationAuto)
      }
      this.isLoadScheduling = false
      this.isLoadAlbum = false
      this.isLoadAnalyze = false
      this.isLoadHistory = false
      this.isLoadWorkshopReturn = false

      this.tabIndex = TAB_IDX_DETAILS
      this.tabName = TAB_DETAILS
    },
    moveTabIndex () {
      this.tabIndex = TAB_IDX_DETAILS
      this.tabName = TAB_DETAILS
    },
    setTabName (name) {
      this.tabName = name
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i].role === role) {
            result = true
          }
        }
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/auto/sinister.vue